
/** Angular Imports */
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 |  exponentialStrength:10}}
 *   formats to: 1024
 */
@Pipe({
    name: 'customDate',
    standalone: false
})
// export class CustomDate extends DatePipe implements PipeTransform {
export class CustomDate implements PipeTransform {
  transform(value: Date | string | number, args?: any): string {

    const dateformat: string = 'MM/dd/yyyy';
    if (value) {
      const datePipe = new DatePipe('en-US'); // Use your desired locale
      return datePipe.transform(value, dateformat);

    }

    return '';
  }
}
@Pipe({
    name: 'customDateSafariSafe',
    standalone: false
})
export class customDateSafariSafe extends DatePipe implements PipeTransform {
  transform(date: any, format: string): any {
    if (date) {
      return moment(date).format(format);
    }
  }
}

@Pipe({
    name: 'pagesFilter',
    standalone: false
})
export class pagesFilter {
  transform(pages, [key]) {
    if (pages[key]) {
      return pages.filter((page) => {
        return page[key] === true;
      });
    }
  }
}
@Pipe({
    name: 'BoldPipe',
    standalone: false
})
export class BoldPipe implements PipeTransform {
  transform(val: any): any {
    const dataText = ([] = val.split('**'));
    const finalText = '<b>' + dataText[1] + '</b>' + dataText[2];
    return finalText;
  }
}

@Pipe({
    name: 'EQPipe',
    standalone: false
})
export class EQPipe implements PipeTransform {
  transform(text: string): string {
    const first = text.split(':')[0];
    let second = text.split(':')[1];
    second = '<span class=\'d-block\'>' + second + '</span>';
    return first + second;
  }
}
@Pipe({
    name: 'BestCareerCluster',
    standalone: false
})
export class BestCareerCluster implements PipeTransform {
  transform(text: string): string {
    if (!text || text.length === 0) {
      return 'Cluster title is empty';
    }
    const colonIdx = text.indexOf(':');
    let clusterTitle: string = '';
    let clusterHeader: string = '';
    if (colonIdx !== -1) {
      clusterHeader = text.substring(0, colonIdx).trim();
      clusterTitle = text.substring(colonIdx + 1).trim();
      return '<strong>' +
        clusterHeader +
        ':&nbsp' +
        '</strong>' +
        '<a target=:"_blank" href="' +
        clusterTitle +
        '">' +
        clusterTitle +
        '</a>';; // Return the original text if no colon is found
    } else {
      return 'Cluster title not provided';
    }

  }
}

@Pipe({
    name: 'MarkdownToLink',
    standalone: false
})
export class TransformMarkdownPipe implements PipeTransform {
  transform(text: string): string {
    /**handles http:// https:// mailto: cases */
    if (text && text.length > 0 && text.includes(':')) {
      return text.replace(
        /\[([^\]]+)\]\(([^\)]+)\)/g,
        "<a href='$2' class='anchorclass' target='_blank'>$1</a>"
      );
    }
    //special case for internal redirect in CareerJr module
    else if (text && text.length > 0 && text.includes('/redirect/fileOccJr/')) {
      return text.replace(
        /\[([^\]]+)\]\(([^\)]+)\)/g,
        "<span class='anchorclass pointer'>$1</span>"
      );
    }
    return text;
  }
}

@Pipe({
    name: 'MarkdownToHiper',
    standalone: false
})
export class TransformMarkdownHiperPipe implements PipeTransform {
  transform(text: string): string {
    /**handles http:// https:// mailto: cases */
    if (text && text.length > 0 && text.includes(':')) {
      return text.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '$2');
    }
    return text;
  }
}

@Pipe({
    name: 'BestCareerMatch',
    standalone: false
})
export class BestCareerMatchPipe implements PipeTransform {
  transform(text: string, item: number, totalItem: number): string {
    if (!text || text.length === 0) {
      return 'Data is not available';
    }

    let clusterTitle: string = text;
    if (item + 1 < totalItem) {
      return '<a target=:"_blank" href="' +
        clusterTitle + '">' + clusterTitle.trim() + '</a>' + ','; // Return the original text if no colon is found
    } else {
      return '<a target=:"_blank" href="' +
        clusterTitle + '">' + clusterTitle.trim() + '</a>'; // Return the original text if no colon is found
    }
  }
}